<template>
  <div class="form-container">
    <div class="el-descriptions-title">评价信息</div>
    <eTableList
      :table-data="tableData"
      :table-label="tableLabel"
      :index-show="false"
      :right-span-method="objectSpanMethod"
    >
      <template #fieldReview="{scope:{row}}">
        <el-input v-model="row.fieldReview" :disabled="type==='2'||isStructured==='1'" type="text"/>
      </template>
      <template #productTest="{scope:{row}}">
        <el-input v-model="row.productTest" :disabled="isStructured==='1'&&type==='2'" type="text"/>
      </template>
      <template #compositeScore="{scope:{row}}">
        <el-input v-model="row.compositeScore" :disabled="isStructured==='1'&&type==='2'" type="text"/>
      </template>
      <template #grade="{scope:{row}}">
        <el-input class="center" v-model="row.grade" :disabled="isStructured==='1'&&type==='2'" type="text"/>
      </template>
      <template #sceneReportAttachName="{scope:{row}}">
        <template v-if="type==='1'?!row.sceneReportAttachName:!row.testReportAttachName">
          <input v-show="false" @change="fileChange" ref="file" type="file">
          <span class="table-handle-btn" @click="add">上传</span>
        </template>
        <template v-else>
          <e-tooltip mode="width" class="margin-r10 table-handle-btn"
                     style="display: inline-block;width: calc(100% - 60px)"
                     :content="type==='1'?row.sceneReportAttachName:row.testReportAttachName"/>
          <span class="table-handle-btn" style="color: #F0250F" @click="remove">删除</span>
        </template>
      </template>
      <template #operate="{scope:{row}}">
        <span class="table-handle-btn" @click="onClear">清空</span>
      </template>
    </eTableList>
  </div>
</template>

<script>
import eTableList from '@/modules/projectA/components/common/e-table-list-merge';
import eTooltip from '@/modules/projectA/components/common/e-tooltip';
import utils from '@/modules/projectA/utils/utils';
import Api from '@/modules/projectA/api/ESorganization';

const { isNumber } = utils;
export default {
  name: 'evaluativeInfo',
  components: { eTableList, eTooltip },
  props: {
    // 1:现场审查，2：实物检测
    type: {
      type: String,
      default: '1'
    },
    // 0：非结构化，1：结构化
    isStructured: {
      type: String,
      default: '0'
    },
    list: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      tableData: []
    };
  },
  watch: {
    list: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.tableData = [...newVal];
        }
      }
    }
  },
  computed: {
    tableLabel() {
      return [
        {
          label: '覆盖范围', param: 'level', align: 'center', width: 130,
          render: ({ level }) => {
            return level && (level + '级');
          }
        },
        { label: '产品名称', param: 'productName', align: 'center', minWidth: 180, tooltip: true },
        {
          label: '产品检测费', param: 'applyAmount', align: 'right', width: 110, render: ({ applyAmount }) => {
            return utils.thousandsSeparator(applyAmount);
          }
        },
        { label: '现场审查分数', slot: 'fieldReview', align: 'center', width: 120 },
        {
          label: '现场审查结论', param: 'fieldReview', align: 'center', width: 120,
          render: ({ fieldReview }) => {
            return isNumber(fieldReview) ? (Number(fieldReview) < 60 ? '不合格' : '合格') : '';
          },
          hidden: this.type === '2'
        },
        { label: '产品测试分数', slot: 'productTest', align: 'center', width: 120, hidden: this.type === '1' },
        { label: '综合得分', slot: 'compositeScore', align: 'center', width: 120, hidden: this.type === '1' },
        { label: '评级', slot: 'grade', align: 'center', width: 120, hidden: this.type === '1' },
        {
          label: '限制范围',
          param: 'scopeOfApplication',
          align: 'center',
          hidden: this.type === '1',
          minWidth: 200,
          tooltip: true
        },
        {
          label: this.type === '1' ? '现场审查报告(pdf)' : '检测报告(pdf)',
          slot: 'sceneReportAttachName',
          align: 'center',
          minWidth: 180
        },
        {
          label: '操作',
          slot: 'operate',
          align: 'center',
          minWidth: 80,
          hidden: this.type === '1' || (this.type === '2' && this.isStructured === '1')
        }
      ].filter(item => !item.hidden);
    }
  },
  methods: {
    /**
     * 选择文件
     * @param target
     */
    fileChange({ target }) {
      const file = target.files[0];
      const i = file.name.lastIndexOf('.');
      if (!file) {
        return;
      }
      // 验证上传类型
      if (['pdf'].includes(file.name.substr(i + 1).toLowerCase())) {
        this.$set(this.tableData[0], this.type === '1' ? 'sceneReportAttachName' : 'testReportAttachName', file.name);
        this.upload(file);
      } else {
        this.$message.warning('仅支持pdf文件上传');
      }
    },
    /**
     * 选择文件
     */
    add() {
      this.$refs.file.click();
    },
    /**
     * 删除文件
     */
    remove() {
      if (this.type === '1') {
        this.$set(this.tableData[0], 'sceneReportAttachName', '');
        this.$set(this.tableData[0], 'sceneReportAttachPath', '');
      } else {
        this.$set(this.tableData[0], 'testReportAttachName', '');
        this.$set(this.tableData[0], 'testReportAttachPath', '');
      }
    },
    /**
     * 清空
     */
    onClear() {
      this.$set(this.tableData[0], 'productTest', '');
      this.$set(this.tableData[0], 'compositeScore', '');
      this.$set(this.tableData[0], 'grade', '');
    },
    /**
     * 点击上传
     * @param file
     */
    async upload(file) {
      let formData = new FormData();
      formData.append('file', file);
      const res = await Api.uploadReportAttachment(formData);
      if (res.code === '200') {
        this.$set(this.tableData[0], this.type === '1' ? 'sceneReportAttachPath' : 'testReportAttachPath', res.data.url);
        this.$message.success('上传成功');
      }
    },
    /**
     * 合并单元格
     * @param row
     * @param columnIndex
     * @returns {{colspan: number, rowspan: *}|{colspan: number, rowspan: number}}
     */
    objectSpanMethod({ row, columnIndex }) {
      // 前四列
      if (columnIndex > 2) {
        return {
          rowspan: this.list.length,
          colspan: 1
        };
      } else {
        return {
          rowspan: 1,
          colspan: 1
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../components/common";

  ::v-deep .el-input__inner {
    text-align: right;
  }

  .center {
    ::v-deep .el-input__inner {
      text-align: center;
    }
  }
</style>
